<template>
    <p class="logo">
        liquidhearts<span class="reg">®</span>
    </p>
</template>

<style scoped>
.logo {
    color: var(--primary-text-color);
    text-wrap: nowrap;
    touch-action: none;
    pointer-events: none;
}

.logo .reg {
    font-family: 'Helvetica Neue LT Std', Helvetica, Arial;
    color: var(--primary-text-color);
    font-size: 11.2px;
    display: inline-block;
    transform: translateY(0.3px);
    font-weight: 800;
}
</style>